import { apiClient } from './api';

export type AdminNotificationType = 'success' | 'warning' | 'info';

export interface AdminNotification {
  id: string;
  title: string;
  time: string;
  type: AdminNotificationType;
}

const toRelativeTime = (value?: string): string => {
  if (!value) return 'vừa xong';

  const timestamp = new Date(value).getTime();
  if (Number.isNaN(timestamp)) return 'vừa xong';

  const diffMs = Math.max(0, Date.now() - timestamp);
  const diffMinutes = Math.floor(diffMs / 60000);

  if (diffMinutes < 1) return 'vừa xong';
  if (diffMinutes < 60) return `${diffMinutes} phút trước`;

  const diffHours = Math.floor(diffMinutes / 60);
  if (diffHours < 24) return `${diffHours} giờ trước`;

  const diffDays = Math.floor(diffHours / 24);
  return `${diffDays} ngày trước`;
};

const mapType = (status: string): AdminNotificationType => {
  if (status === 'resolved') return 'success';
  if (status === 'open') return 'warning';
  return 'info';
};

export const notificationService = {
  async getLatest(limit = 5): Promise<AdminNotification[]> {
    const response = await apiClient.get('/support/tickets', {
      params: { page: 1, limit },
    });

    const root = response.data?.data ?? response.data ?? {};
    const items = Array.isArray(root)
      ? root
      : Array.isArray(root?.items)
        ? root.items
        : Array.isArray(root?.data)
          ? root.data
          : [];

    return items.map((item: any) => {
      const tenantName = item.tenant_name ?? item.tenantName ?? 'Khách thuê không xác định';
      const subject = item.subject ?? 'Cập nhật hỗ trợ';
      const status = item.status ?? 'in_progress';

      return {
        id: item.id ?? item._id ?? `${tenantName}-${subject}`,
        title: `${tenantName}: ${subject}`,
        time: toRelativeTime(item.updated_at ?? item.updatedAt),
        type: mapType(status),
      };
    });
  },
};

export default notificationService;